export default __webpack_public_path__ + "static/media/company_A.3c8cabd9.png";